import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    margin-top: 75px;
    padding: 0 10px;
    width: 100%;
    @media (min-width: 720px) {
        margin: 40px 0 0 200px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-left: 25px;
    }
`;

export const PageTitle = styled.h1`
    color: #006560;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    @media (min-width: 720px) {
        text-align: start;
    }
`;

export const CountContainer = styled.span`
    color: #9BA8C3;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
`;

export const HeaderContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: flex-start;
    margin-block: 25px;
    @media (min-width: 720px) {
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
    }
`;

export const ContainerList = styled.div`
    align-items: center;
    background: #F2F2F2;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    padding: 10px;
    width: 100%;
    @media (min-width: 720px) {
        width: 95%;
    }
`;

export const LineTitle = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    width: 98%;
`;

export const TitleText = styled.h1`
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    max-width: 33%;
    overflow: auto;
    white-space: nowrap;
    width: 33%;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const LineList = styled.a`
    align-items: center;
    background: #FFF;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    text-decoration: none;
    width: 98%;
`;

export const ListText = styled.h1`
    color: #333;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 33%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 33%;
`;

export const ListButton = styled.button`
    background: none;
    border: none;
    border-radius: 5px;
    color: #33CC99;
    cursor: pointer;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    outline: none;
    padding-inline: 5px;
    white-space: nowrap;
    &:disabled{
        background: #A3A3A3;
        color: #fff;
        cursor: auto;
    }
`;

export const FilterInput = styled.input`
    border: none;
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 20px */
    outline: none;
`;

export const InputContainer = styled.div`
    align-items: center;
    border: 1px solid #3C9;
    border-radius: 10px;
    display: flex;
    gap: 15px;
    justify-content: center;
    padding: 12px 22px 12px 20px;
`;

export const ContainerHead = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 15px;
    width: 100%;
    @media (min-width: 720px) {
        flex-direction: row;
        width: 95%;
    }
`;

export const ContainerRow = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 90%;
    justify-content: flex-start;
    overflow: auto;
    width: 100%;
    @media (min-width: 1320px) {
        align-items: flex-start;
        flex-direction: row;
        justify-content: center;
    }
`;

export const ImageIcon = styled.img`
    height: 24px;
    width: 24px;
`;

export const ButtonsContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 25px;
    justify-content: center;
    justify-self: flex-end;
    padding-bottom: 20px;
    width: 100%;
    @media (min-width: 1320px) {
        flex-direction: row;
        justify-content: flex-end;
        width: 90%;
    }
`;

export const ContainerColumn = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-content: flex-start;
    padding: 20px;
    width: 80%;
    @media (min-width: 1320px) {
        width: 30%;
    }
`;

export const CardsContainer = styled.ul`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    padding: 20px;
    width: 100%;
`;

export const Card = styled.li`
    background: #FFF;
    list-style: none;
    width: 100%;

    h3.profile-view__title {
        color: #333;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 6px;
    }

    div.profile-view__card {
        border: 1px solid #333;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 10px;
    }

    div.profile-view__header {
        align-items: center;
        display: flex;
        gap: 10px;
    }

    span.profile-view__name {
        font-size: 18px;
        font-weight: 600;
    }

    div.profile-view__values {
        display: flex;
        gap: 10px;
        flex-direction: column;
    }

    span.profile-view__old-value {
        font-size: 16px;
        font-weight: 400;
    }

    span.profile-view__new-value {
        font-size: 18px;
        font-weight: 600;
    }

    div.profile-view__info{
        display: flex;
        gap: 28px;
    }

    p.profile-view__description {
        align-items: center;
        background: #ECECEC;
        border-radius: 5px;
        display: flex;
        color: #333;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 10px;
    }
`;

export const CardIcon = styled(SVG)`
    width: 24px;
    height: 24px;

  & path {
    fill: ${({ $isSpecial }) => ($isSpecial ? '#FFF' : 'currentColor')};
    stroke: ${({ $isSpecial }) => ($isSpecial ? 'currentColor' : 'none')};
  }
`;

export const ContainerSelect = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0.2;
    justify-content: center;
    padding: 20px;
    width: 100%;
    gap: 15px;
    @media (min-width: 720px) {
        flex-direction: row;
        justify-content: flex-start;
        padding: 0;
    }
`;